
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["init","search","autoSuggest"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "ba40bdebe52e7b136130.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "ba40bdebe52e7b136130.worker.js");
					addMethods(w, methods)
					
					return w
				}
			